// Pull colors.json into build so webpack watches it
import '../data/colors.json';

// Client styles
import '../scss/client.scss';
import { initArcadiaSiteHeader } from '../../blocks/site-header/script';
import { initHomeHero } from '../../blocks/home-hero/script';
import { initResourceArchiveHero } from '../../blocks/resource-archive-hero/script';
import { initResourceArchiveList } from '../../blocks/resource-archive-list/script';
import { initCuratedResource } from '../../blocks/curated-resource/script';
import { initPartnershipArchiveList } from '../../blocks/partnership-archive-list/script';
import { initSearchResults } from '../../blocks/search-results/script';
import { initShareButton } from '../../blocks/share-button/script';
import { initMediaRss } from '../../blocks/media-rss/script';
import { initStatsCounter } from './stats-counter';
import { initTabs } from './tabs';
import { initAnimatedTiles } from './animated-tiles';
import { initMegaNav } from './mega-nav';
import { initResourceTocDrawer } from './resource-toc-drawer';
import { initHubspotSmartForm } from './hubspot-smart-form';
import { initSubtleCirclesReveal } from './subtle-circles-reveal';

if (typeof window !== 'undefined') {
	function arcadiaOnReady() {
		initArcadiaSiteHeader();
		initHomeHero();
		initResourceArchiveHero();
		initResourceArchiveList();
		initCuratedResource();
		initPartnershipArchiveList();
		initSearchResults();
		initShareButton();
		initMediaRss();
		initStatsCounter();
		initTabs();
		initAnimatedTiles();
		initMegaNav();
		initResourceTocDrawer();
		initHubspotSmartForm();
		initSubtleCirclesReveal();
	}
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', arcadiaOnReady);
	} else {
		arcadiaOnReady();
	}
}
